import { Component, OnInit,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FundsTitleService } from 'src/app/Service/Funds/FundsTitle.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-FundsTitleForm',
  templateUrl: './FundsTitleForm.component.html',
  styleUrls: ['./FundsTitleForm.component.scss']
})
export class FundsTitleFormComponent implements OnInit {

  Token: String = ""
  @Input() inner_Funds:General_Interface=Empty_General_Interface()

  constructor(
    private Funds_Service:FundsTitleService,
    private Nav_Service:NavService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.FormFunds=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.get_Form_Title().setValue(this.inner_Funds.title)

    this.Nav_Service.CheckValidPage(this.Token,1154).subscribe(
      data=>{

      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  //#region  Form Add

  FormFunds:FormGroup;

  get_Form_Title(){
    return this.FormFunds.get('Title') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitFormFunds(){
    var Record:General_Interface =Empty_General_Interface()
    Record.id=this.inner_Funds.id
    Record.title=this.get_Form_Title().value

    this.InProccessing=true
    this.Funds_Service.AddEditFundsTitle(Record,this.Token).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
        }
        else {
          this.inner_Funds.id=data.id
          this.Alertify_Service.SuccessMessage("Information saved successfully.")
        }
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


}
